.actions {
  display: flex;
}

.other-actions {
  position: relative;
}

.menu {
  position: absolute;
  background-color: var(--main-background);
  z-index: 1;
  border: 1px solid var(--menu-border);
  box-shadow: 0 0 10px var(--shadow);
}
